import { toast } from "sonner";

export const copyToClipboard = async (value, label = "Value") => {
  try {
    await navigator.clipboard.writeText(String(value ?? ""));
    toast.success(`${label} copied to clipboard`);
    return true;
  } catch {
    toast.error(`Unable to copy ${label.toLowerCase()}`);
    return false;
  }
};
